import { FormikHelpers, FormikValues } from 'formik';
import React from 'react';
import { number, object } from 'yup';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Form, { Botao as BotaoForm, Campo, Selecao } from 'Component/Form';
import Modal from 'Component/Modal';
import Modulo from 'Interface/Modulos';
import { Erro } from 'Interface/Requisicao';
import {
  useAdicionarAvaliacaoMutation,
  useRecuperarModulosQuery,
} from 'Service';

interface Props {
  exibir: boolean;
  cursoId?: number;
  aoFechar: (estado: boolean) => void;
}

const regras = object({
  modulo_id: number().required('Obrigatório'),
  prazo: number().positive('Deve ser positivo').required('Obrigatório'),
});

const Adicionar = ({
  exibir,
  aoFechar,
  cursoId,
}: Props): React.ReactElement => {
  const toast = useToast();
  const [adicionarAvaliacao] = useAdicionarAvaliacaoMutation();

  const { data: { modulos } = {} } = useRecuperarModulosQuery({
    finder: 'listaJson',
    options: { curso_id: cursoId },
    sort: 'nome',
    direction: 'asc',
  });

  const adicinar = async (
    dados: Modulo,
    form: FormikHelpers<FormikValues>
  ): Promise<void> => {
    try {
      await adicionarAvaliacao({ ...dados, curso_id: cursoId }).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      aoFechar(false);
    } catch (erro) {
      const { data: errors } = erro as Erro;

      form.setStatus(errors);

      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <Modal exibir={exibir} aoFechar={aoFechar}>
      <Form onSubmit={adicinar} regras={regras}>
        <Selecao
          name="modulo_id"
          rotulo="Qual é o módulo da avaliação"
          opcoes={modulos}
        />
        <Campo name="prazo" rotulo="Prazo para liberar prova em dias" />

        <div className="mt-5">
          <BotaoForm>Salvar</BotaoForm>
          <Botao ms onClick={() => aoFechar(false)} tema="light">
            Cancelar
          </Botao>
        </div>
      </Form>
    </Modal>
  );
};

export default Adicionar;
